import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { ChatService } from "./service/chat.service";
import { ImageUrls } from "src/app/services/s3buket";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { HttpBackend, HttpClient, HttpEventType } from "@angular/common/http";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { ActivatedRoute, Router } from "@angular/router";
import { orderBy } from "lodash";
import { ToastrService } from "ngx-toastr";
import { Lightbox } from "ngx-lightbox";
import { CompressImageService } from "src/app/services/compress-image.service";
import { take } from "rxjs/operators";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { chatEnvironment } from "../../../environments/chatEnvironment";
import { Subscription } from "rxjs";
@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.css"]
})
export class ChatComponent implements OnInit, AfterViewInit, OnDestroy {
  firebaseUsers = chatEnvironment.users;
  firebaseMessage = chatEnvironment.messages;
  firebaseChats = chatEnvironment.chats;
  firebaseJobs = chatEnvironment.jobs;
  firebaseNotification = chatEnvironment.notifications;
  deleteMessage = chatEnvironment.deleteMessages;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.recruiter
  globalUrlChatDirectory = ImageUrls.BaseUrl + ImageUrls.directories.chatDirectory
  @ViewChildren("messagesList") messages!: QueryList<any>;
  @ViewChild("messagesListContainer") content!: ElementRef;
  uploadType: any;
  sendMsg: any;
  job_ID: any;
  userChats: any;
  messagesList: any = [];
  chatDialog: any = [];
  selectedUserChat: any;
  selectedUserChatData: any;
  messageText: string = "";
  userId: string = "";
  firebaseMsg: any = "";
  chatListSearchBy: string = "";
  chatListFilterBy: string = "";
  choosedFileBase64: any;
  choosedFile: any;
  private messageListener: any;
  private messageListener1: any;
  private delMessageListener: any;
  private userDetailsListner!: Subscription;

  constructor(private compressImage: CompressImageService, private toastrService: ToastrService, private db: AngularFireDatabase, private chatService: ChatService, private api: AdminService, private router: Router,
    private handler: HttpBackend, private userDetailsService: UserDetailsService, private _activatedRoute: ActivatedRoute, private _lightbox: Lightbox, private _lightboxGallery: Lightbox) {

    if (this.userDetailsListner)
      this.userDetailsListner?.unsubscribe();
    this.userDetailsListner = this.userDetailsService.userDetailsObserver.subscribe(userData => {
      if (userData) {
        this.userId = userData?.id;
        if (this.userId) {
          console.log("this.userDetailsListner = 1");
          this.getChatDialogs(this.userId, "1");
          this.chatService.setUserDetails(userData);
        }
      }
    });

    if (this.userDetailsService.userDetails) {
      this.userId = this.userDetailsService.userDetails?.id;
      if (this.userId) {
        console.log("this.userDetailsListner = 2");
        this.getChatDialogs(this.userId, "1");
        this.chatService.setUserDetails(this.userDetailsService.userDetails);
      }
    }

    this._activatedRoute.queryParams.subscribe((params) => {
      if (params.id) {
        this.job_ID = params.id;
        this.getJobDetails(params.id);
        console.log("this._activatedRoute = 1");
      }
    })
    console.log(this.userDetailsListner);
  }


  ngOnDestroy(): void {
    this.messageListener?.unsubscribe();
    this.messageListener1?.unsubscribe();
    this.delMessageListener?.unsubscribe();
    this.userDetailsListner?.unsubscribe();
    this.delMessageListener?.unsubscribe();
    this.messageListener = null;
    this.messageListener1 = null;
    this.delMessageListener = null;
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
    this.scrollToBottom();
    this.messages.changes.subscribe(this.scrollToBottom);
  }

  scrollToBottom = () => {
    try {
      this.content.nativeElement.scrollTop = this.content.nativeElement.scrollHeight;
    } catch (err) { }
  }
  getJobDetails(jobId: string) {
    // this.api.loader(false);
    this.api.getDatas(apiUrl._getJobDetail + "/" + jobId).subscribe((res) => {
      console.log("this.getJobDetails = 1");

      this.chatService.initiateChat(res.data).then((chatDialog: any) => {
        console.log("this.chatService.initiateChat = 1");
        this.getchatFromAPI(chatDialog.chat_dialog_id);
        this.selectedUserChat = chatDialog;
        this.selectedUserChat['delete_status'][this.userId] = 0;
      });
    }, err => { console.log(err.error.message, "err") })
  }

  status(chat_dialog_id, user_id, job_id, userStatus, jobStatus) {
    var blockUserArr = {};
    blockUserArr[job_id] = jobStatus ? jobStatus : 0
    blockUserArr[user_id] = userStatus ? userStatus : 0
    var chatDialog = this.db.object(`${this.firebaseChats}/${chat_dialog_id}`).update({
      "block_status": blockUserArr
    });

    const changedObjects = this.userChats.filter(obj => {
      if (this.selectedUserChat.chat_dialog_id == obj.chat_dialog_id) {
        this.selectedUserChat = obj;
      }
    });
  }

  getchatFromAPI(chat_dialog_id) {
    let data = {
      "chatDialogId": chat_dialog_id,
    }
    console.log("this.getchatFromAPI = 1");
    this.api.getData(apiUrl._chatHistory, data).subscribe(async (res) => {
      console.log("this.getchatFromAPI = 2");
      this.messagesList = res.data;
      this.messagesList = this.messagesList.sort((a, b) => a["firebase_message_time"] - b["firebase_message_time"]);
      this.initializeMessageObserver();
    },
      err => {
        console.log(err, "err");
      });
  }

  initializeMessageObserver() {
    if (this.messageListener) {
      this.messageListener.unsubscribe();
    }

    this.messageListener = this.chatService.getMessagesObserveable(this.selectedUserChat).subscribe((messages) => {
      this.firebaseMsg = Object.assign([], messages);
      this.firebaseMsg.filter(item => {
        if (item?.message_id) {
          let count = 0;
          this.messagesList.filter(data => {
            if (item?.message_id == data?.message_id) {
              count = 1;
            }
          })
          if (count == 0) {
            if (item?.chat_dialog_id === this.selectedUserChat.chat_dialog_id) {
              this.messagesList.push(item);
            }
          }
        }
      })
      // this.api.loader(false);
      //this.messagesList = this.firebaseMsg
      this.messagesList = this.messagesList.sort((a, b) => a["firebase_message_time"] - b["firebase_message_time"]);
      var statusU = this.db.object(`${this.firebaseChats}/${this.selectedUserChat.chat_dialog_id}/unread_count`).update({
        [this.selectedUserChat.user_id]: 0
      });

    });
  }

  getTime(val: any) {
    return this.messagesList[val - 1].message_time
  }

  getChatDialogs(userId: string, type: string) {
    if (this.messageListener1) {
      this.messageListener1.unsubscribe();
    }


    this.messageListener1 = this.db.list(`${this.firebaseChats}`,
      query => query.orderByChild("user_id").equalTo(userId)
    ).valueChanges().subscribe(listNew => {
      this.chatDialog = listNew ? listNew[0] : [];
      this.userChats = Object.assign([], listNew);    
     
      this.userChats = this.userChats.filter(x => x.delete_status ? x.delete_status[userId] == 0 : true);
      this.userChats = this.userChats.sort((a, b) => b["last_message_time"] - a["last_message_time"]);
      if (type === "1") {
        setTimeout(() => {
          type = "0"
        }, 1000);
      } else {
        const filter_array = this.userChats.filter(x => x.job_id == this.job_ID);
        if (this.selectedUserChat.job_id == this.job_ID) {
          this.selectedUserChat = filter_array[0];
        }
        if (filter_array.length == 0) {
          this.selectedUserChat = "";
          this.router.navigate(["/chat"]);
        }
      }
      console.log("avtar11", this.userChats)
      this.getJobDialogs();
    });
  }

  openChatBox(jobId: string) {
    this.router.navigate(["chat"], { queryParams: { id: jobId } })
  }

  sendMessage() {
    let userBlock: any;
    let jobBlock: any;
    const findStatus = this.userChats.filter(obj => {
      if (obj.chat_dialog_id === this.selectedUserChat.chat_dialog_id) {
        userBlock = obj.block_status[this.selectedUserChat.user_id] ? obj.block_status[this.selectedUserChat.user_id] : 0;
        jobBlock = obj.block_status[this.selectedUserChat.job_id] ? obj.block_status[this.selectedUserChat.job_id] : 0;
      }
    });
    if (userBlock == 0) {
      if (jobBlock == 0) {
        this.changeDeleteDialogStatus(false);
        this.chatService.sendMessage({ message: this.messageText!, currentUserChat: this.selectedUserChat });
        this.sendMsg = 1;
        this.messageText = "";

      } else {
        this.toastrService.error("This person has blocked you.", "", {
          timeOut: 5000,
        });
        this.messageText = "";
      }

    } else {

      this.toastrService.error("You has blocked this person. To continue, you need to unblock this person.", "", {
        timeOut: 5000,
      });
      this.messageText = "";
    }



    // else {
    //   this.toastrService.error("You has blocked this person. To continue, you need to unblock this person.", "", {
    //     timeOut: 5000,
    //   });
    //   this.messageText = "";
    // }
  }

  sendFile() {
    this.uploadFileToS3(this.choosedFile);
  }

  clearUserChat() {
    this.api.showConfirmationDialog("Are you sure you want to clear the chat history with <strong> " + "" + this.selectedUserChat?.company_name + " </strong> for <strong>" + this.selectedUserChat?.job_name + "</strong> ?", "Yes", "No").then((result) => {
      if (result.value) {

        this.chatService.clearUserChat(this.selectedUserChat);
        this.messagesList = [];
        this.selectedUserChat.clear_chat_time[this.userId] = this.chatService.currentTime;
        // window.location.reload();
      }
    })
  }

  blockUnblockUser() {
    let type = (this.selectedUserChat?.block_status[this.userId] == 1) ?"unblock":"block";
    this.api.showConfirmationDialog("Are you sure you want to " + type + " the messages for <strong>" + this.selectedUserChat?.job_name + "</strong> from <strong>" + this.selectedUserChat?.company_name + "</strong> ?", "Yes", "No")
      .then((result) => {
        if (result.value) {
          let usertype = (this.selectedUserChat?.block_status[this.userId] == 1)?0:1;
          //let jobtype = this.selectedUserChat?.block_status[this.selectedUserChat.job_id];
          this.db.object(`${this.firebaseChats}/${this.selectedUserChat?.chat_dialog_id}/block_status`).update({
            [this.selectedUserChat?.user_id]: usertype,
            // [this.selectedUserChat?.job_id]: jobtype
          });
          this.selectedUserChat.block_status[this.userId] = usertype
          this.userChats.block_status[this.userId] = usertype
        }
      })
  }

  deleteUser() {
    this.api.showConfirmationDialog("Are you sure you want to delete this chat?", "Yes", "No")
      .then((result) => {
        if (result.value) {        
          if (this.selectedUserChat.delete_status[this.selectedUserChat.job_id] == 1) {
            this.db.object(`${this.firebaseMessage}/${this.selectedUserChat.chat_dialog_id}/`).remove();
            this.db.object(`${this.firebaseUsers}/${this.selectedUserChat.user_id}/`).remove();
            this.db.object(`${this.firebaseJobs}/${this.selectedUserChat.job_id}/`).remove();
            this.db.object(`${this.firebaseNotification}/${this.selectedUserChat.chat_dialog_id}/`).remove();
            this.db.object(`${this.firebaseChats}/${this.selectedUserChat.chat_dialog_id}/`).remove()
          } else {      
            this.chatService.clearUserChat(this.selectedUserChat);
            this.messagesList = [];
            this.selectedUserChat.clear_chat_time[this.userId] = this.chatService.currentTime;
            this.changeDeleteDialogStatus(true);
          }

          this.toastrService.success("Chat dialog deleted successfully.", "", {
            timeOut: 5000,
          });
          this.selectedUserChat = "";
          this.getChatDialogs(this.userId, "1");
          this.router.navigate(["/chat"])
        }
      })
  }

  changeDeleteDialogStatus(isDelete: boolean) {
    var deleteUserArr = {};
    deleteUserArr[this.selectedUserChat.job_id] = 0
    deleteUserArr[this.selectedUserChat.user_id] = isDelete ? 1 : 0
    this.db.object(`${this.firebaseChats}/${this.selectedUserChat.chat_dialog_id}`).update({
      "delete_status": deleteUserArr
    });
  }

  onFilterChatList(filterType: string) {
    this.chatListFilterBy = filterType;
  }

  upload(event) {
    if (event.target.files[0].size <= 20000000) {
      const selectedFile = event.target.files[0];
      const idxDot = selectedFile.name.lastIndexOf(".") + 1;
      var extFile = selectedFile.name
        .substr(idxDot, selectedFile.name.length)
        .toLowerCase();
      if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.choosedFileBase64 = reader.result as string;
        }
        reader.readAsDataURL(file)
        this.compressedUploadedFile(file, 2)
        event.target.value = null;
      } else if (extFile == "pdf" || extFile == "doc" || extFile == "docx") {

        //this.spinner.show();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.choosedFileBase64 = reader.result as string;
        }
        reader.readAsDataURL(file)
        // this.compressedUploadedFile(file, 3)
        this.choosedFile = file
        this.uploadType = 3
        event.target.value = null;
      } else {
        this.toastrService.error(
          "Only jpg/jpeg, png, pdf and doc files are allowed!",
          "",
          {
            timeOut: 5000,
          }
        );
      }
    } else {
      this.toastrService.error("File size exceeds maximum limit 20MB.", "", {
        timeOut: 5000,
      });
    }

  }
  compressedUploadedFile(file, number) {
    this.compressImage.compress(file)
      .pipe(take(1))
      .subscribe(compressedImage => {
        this.choosedFile = compressedImage
        this.uploadType = number

      })
  }

  uploadFileToS3(file: any) {
    const data = {
      "directory": ImageUrls.directories.chatDirectory,
      "fileName": file.name,
      "contentType": file.type
    }
    this.api.postData(apiUrl._getS3SignedURL, data)
      .subscribe(signedUrlRes => {
        this.api.loader(true);
        let http = new HttpClient(this.handler);
        http.put<any>(signedUrlRes.data.uploadURL, file, { reportProgress: true, observe: "events" }).subscribe(res => {
          if (res.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * res.loaded / res.total! || 0);
            if (percentDone == 100) {
              this.api.loader(false);
              this.changeDeleteDialogStatus(false);
              this.chatService.sendMessage({ fileName: signedUrlRes.data.fileName, fileType: file.type, currentUserChat: this.selectedUserChat });
              this.sendMsg = 1;
              this.resetSelectedFile();
            }
          }
        })
      })
  }

  resetSelectedFile() {
    this.choosedFile = null;
    this.choosedFileBase64 = null;
  }

  openImagePreview(imageName: string): void {
    let imageArr: any = [{ src: this.globalUrlChatDirectory + imageName }]
    this._lightbox.open(imageArr, 0);
  }

  extension(): string {
    return this.choosedFileBase64.split(";")[0].split("/")[1];
  }

  deleteSingleMsg(chat_dialog_id, message_id, jobId) {

    this.api.showConfirmationDialog("Are you sure you want to delete this ? ", "Yes", "No").then((result) => {
      if (result.value) {
        this.chatService.deleteSingleMsg(chat_dialog_id, message_id);
        const index = this.messagesList.findIndex(item => item.message_id === message_id)
        this.messagesList.splice(index, 1);
        let delMessageIndex = this.messagesList.length>0?this.messagesList.length:"";
        console.log("delMessageIndex", delMessageIndex,  this.messagesList.length)
        if(delMessageIndex){
          if((this.selectedUserChat.clear_chat_time && this.selectedUserChat.clear_chat_time[this.selectedUserChat.user_id]) < (this.messagesList[this.messagesList.length-1]?.message_time) && (this.selectedUserChat.chat_dialog_id === this.messagesList[this.messagesList.length-1]?.chat_dialog_id)){
            delMessageIndex= delMessageIndex;
          }else{
            delMessageIndex = ""
          } 
        }
       

        this.db.object(`${this.firebaseChats}/${chat_dialog_id}`).update({
          "last_message": { [jobId]:delMessageIndex? this.messagesList[this.messagesList.length-1].message:'', [this.userId]: delMessageIndex ? this.messagesList[this.messagesList.length-1].message:'' },
          "last_message_time":delMessageIndex ? Number(this.messagesList[this.messagesList.length-1].message_time):''
        });

        this.api.loader(false);
        let data = {
          messageIds: [message_id]
        }
        this.api.putData(apiUrl._deleteMsg, data).subscribe((res) => {
          var messagePush = this.db.list(`${this.deleteMessage}`).push({})
          var delStatusArr = {};
          delStatusArr[message_id] =message_id+','+chat_dialog_id;    
          var aa = this.db.object(`${this.deleteMessage}/${jobId}`).update(delStatusArr);
        })
      }
    })
  }
  getJobDialogs() {
    if (this.delMessageListener) {
      this.delMessageListener.unsubscribe()
    }
    this.delMessageListener = this.db.list(`${this.deleteMessage}/${this.userId}`, query => query.limitToLast(20)).valueChanges().subscribe((x: any) => {
      if (x.length > 0) {
        x.map(item => {
          const index = this.messagesList.findIndex(object => {
            return object.message_id == item.split(',')[0];
          });
          console.log("index", index)
          if (index ==0 || index>0) {
            this.messagesList.splice(index, 1);
            setTimeout(() => {
              this.db.object(`${this.deleteMessage}/${this.userId}/${item.split(',')[0]}`).remove();
            }, 50);
          }
        })
      }
    })
  }
}